import { createSelector } from 'reselect';
import { RootState } from '../../store/store';
// import { RegionNameById } from '../../../components/pages/CarrierWeightPricing/enums/regions.enum';
import { groupBy, uniq } from 'lodash';
import { Region, RegionNumber } from '../../../components/pages/CarrierWeightPricing/components/TNTExcelParserV2';
import { CarrierWeightPricing } from '../../../models/entities/admin/carrierWeightPricing';

const carrierWeightPricing = (state: RootState) => state.carrierWeightPricing.carrierWeightPricing;
const carrierPricingResponse = (state: RootState) => state.carrierWeightPricing.carrierPricingResponse;
const selectedCarrierCode = (state: RootState) => state.carrierWeightPricing.seletedCarrierCode;

const getRegionTransformerPricing = createSelector(carrierWeightPricing, (carrierWeightPricing) => {
    console.log(carrierWeightPricing);
    // Create a composite key for weight and type
    const weightTypeItems = carrierWeightPricing.map((item) => ({
        ...item,
        weightType: `${item.weight}_${item.type}`
    }));

    // Get unique composite keys
    const weightTypes = uniq(weightTypeItems.map((c) => c.weightType));

    // Group by composite key
    const groupedArr: Record<string, typeof weightTypeItems> = groupBy(weightTypeItems, 'weightType');
    const responseArr = [];

    for (const weightType of weightTypes) {
        const items = groupedArr[weightType];
        if (items && items.length > 0) {
            const response: any = {
                weight: items[0].weight,
                carrierCode: items[0].carrierCode,
                type: items[0].type
            };

            items.forEach((c) => {
                // Convert region number to region string using the enum
                const regionEnum = c.region as RegionNumber;
                const regionName = Region.numberToString(regionEnum);

                // Set the price using the region string as the property name
                response[regionName] = c.price;
            });

            responseArr.push(response);
        }
    }

    return responseArr;
});

const regionsInData = createSelector(carrierWeightPricing, (carrierWeightPricing: CarrierWeightPricing[]) => {
    return uniq(
        carrierWeightPricing.map((c) => {
            // Convert the numeric region ID to its string representation using the enum
            const regionEnum = c.region as RegionNumber;
            return Region.numberToString(regionEnum);
        })
    );
});

const selectors = {
    carrierWeightPricing,
    carrierPricingResponse,
    selectedCarrierCode,
    getRegionTransformerPricing,
    regionsInData
};

export default selectors;
